// SSG entry. vite-react-ssg owns the bootstrap: it builds the router
// (createBrowserRouter on the client, a static handler at build time),
// wraps the app in HelmetProvider + RouterProvider, and auto-mounts on
// the client when this module is imported. We only hand it the routes.
//
// App-wide providers (QueryClient), the session bootstrap, and the API
// health monitor live in RootLayout — the root route element — so they
// run inside the router context vite-react-ssg creates.

import { ViteReactSSG } from "vite-react-ssg";

import { routes } from "@/routes";
import "./index.css";

export const createRoot = ViteReactSSG({ routes });
